<template>
    <div>
        <h2 class="c-search-page__results-title">In the texts ({{ resultsToDisplay.length }}) <span class="c-search-page__anchor" id="text-results"></span></h2>
        <template v-if="loading">
            <Loader/>
        </template>
        <template v-else-if="results && results.length > 0">
            <div class="c-search-result c-search-result--playtext" v-for="(result, index) in resultsToDisplay" :key="index">
                <div class="c-post-card c-post-card--playtext">
                    <a class="c-post-card__cover-link" :href="workLink(result)">
                        <span class="u-hidden-visually">{{ result.play.title }} - {{ formatLineNumber(result.line) }}</span>
                    </a>
                    <div class="c-post-card__details c-content">
                        <h3 class="c-post-card__title">{{ result.play.title }} - {{ formatLineNumber(result.line) }} <i class="fal fa-angle-right" aria-hidden="true"></i></h3>
                        <div class="c-post-card__excerpt">
                            <span class="" style="font-weight: bold;" v-if="result.speaker">{{ result.speaker }}: </span>
                            <span v-html="result.text"></span>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="results.length === 0 && !loading">
            <div class="c-content">
                <p>Sorry, no texts matched your search. Please try broadening your search.</p>
            </div>
        </template>
    </div>
</template>

<script>
    import 'lodash.debounce'
    import {EventBus} from "../event-bus"
    import Loader from "./Loader"

    export default {
        name: "WorkResults",
        components: {
            Loader
        },
        props: [
            'query',
            'activeWorks'
        ],
        watch: {
            "query": function(query, oldQuery) {
                if (query !== oldQuery) {
                    this.fetchResults(query)
                }
            }
        },
        data() {
            return {
                results: [],
                loading: true
            }
        },
        computed: {
            resultsToDisplay: function() {
                if (this.activeWorks.length === 0) {
                    EventBus.$emit('update-text-results-count', this.results.length)
                    return this.results
                }
                let returnResults = this.results.filter((result) => {
                    return this.activeWorks.map(item => item.id).includes(result.play.id)
                })
                EventBus.$emit('update-text-results-count', returnResults.length)
                return returnResults
            }
        },
        mounted() {
            this.fetchResults(this.query)
        },
        created() {
            this.fetchResults = _.debounce(this.fetchResults, 600)
        },
        methods: {
            formatLineNumber(line) {
                if (line.startsWith('poem.')) {
                    return line.replace('poem.', 'Line ')
                }
                return line
            },
            fetchResults(query) {
                if (query === '') {
                    this.results = []
                    EventBus.$emit('update-text-results-count', 0)
                    this.loading = false
                    return;
                }
                this.loading = true
                fetch('https://www.folgerdigitaltexts.org/corpus/searchWord/' + query + '.json')
                .then(response => {
                    if (response.status !== 200) {
                        console.log(response)
                        this.results = []
                        this.loading = false
                        EventBus.$emit('update-text-results-count', 0)
                    }
                    return response.json()
                }).then(content => {
                    this.results = content.searchResults.results.map((item) => {
                        return item ? item.result : false
                    })
                    EventBus.$emit('update-text-results-count', this.results.length)
                    this.loading = false
                })
            },
            workLink(data) {
              const work = this.$works.find(work => work.id === data.play.id)
              if (work) {
                return `${work.link}read/${data.location.page}/?q=${this.query}#line-${data.location.anchor}`
              }

              return '#'
            }
        }

    }
</script>

<style scoped>

</style>
